module.exports = __webpack_public_path__ + "img/11.c2f3406c.png";